/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import ls from 'localstorage-slim'
import React, { useCallback, useEffect, useState } from 'react'
import styled, { createGlobalStyle } from 'styled-components'

import { Categories, useAnalytics } from '../../lib/analytics'
import CivicCookieSidebar from './civicCookieSidebar'

function hasClass(elem, className) {
  return elem.className.split(' ').indexOf(className) > -1
}

const CIVIC_COOKIE_TTL = 7776000 // 90 days to expire

// Overwriting Civics CSS
const GlobalStyle = createGlobalStyle`
 #ccc-button-holder{
   display: none;
 }
 #cc-panel {
   background-color: inherit;
 }
 #ccc-end {
    background-color: inherit;
    border-top: 0.0625rem solid white;
    bottom: 0;
    left: 10%;
    margin-bottom: 0!important;
    padding: 1rem 0 1rem 1.5rem;
    position: fixed;
    width: 100%;
    z-index: 1202;
    @media (min-width: 26.625rem) {
      border-top: none;
      bottom: initial;
      box-shadow: none;
      padding: initial;
      position: initial;
      width: initial;
    }
 }
  #ccc-dismiss-button {
    background-color: transparent!important;
    span {
      background-color: transparent!important;
    }
  }
`

const CivicCookieBanner = styled.div`
  .civic_cookie--ws_style {
    background-color: #0c1439;
    h2 {
      font-family: Lato, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue',
        Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
    }
    .civic_cookie__button {
      &:hover {
        background-color: #000006;
      }
    }
    .civic_cookie__button--primary {
      background-color: #cb1977;
      color: white;
      &:hover {
        background-color: #980044;
      }
    }
  }
  .civic_cookie--coll_style {
    background-color: #1257f2;
    h2 {
      font-family: korolev, Inter, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI',
        'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',
        'Segoe UI Symbol';
    }
    .civic_cookie__button {
      &:hover {
        background-color: #0024bf;
      }
    }
    .civic_cookie__button--primary {
      background-color: #f53a27;
      color: white;
      &:hover {
        background-color: #c20700;
      }
    }
  }
  .civic_cookie--rc_style {
    background-color: #ee961b;
    .civic_cookie__button {
      &:hover {
        background-color: #0024bf;
      }
    }
    .civic_cookie__button--primary {
      background-color: #ee2842;
      color: white;
      &:hover {
        background-color: #bb000f;
      }
    }
  }
  .civic_cookie__overlay {
    backface-visibility: hidden;
    background: rgba(0, 0, 0, 0.4);
    bottom: 0;
    left: 0;
    opacity: 1;
    perspective: 0;
    position: fixed;
    right: 0;
    top: 0;
    will-change: opacity;
    z-index: 1200;
  }
  .civic_cookie__banner {
    bottom: 0;
    color: white;
    height: 90%;
    display: flex;
    align-items: center;
    position: fixed;
    padding: 0rem 2rem;
    width: 100%;
    z-index: 1201;
    a {
      color: white;
    }
    @media (min-width: 50rem) {
      height: 50vh;
      padding: 0rem 10%;
    }
  }
  .civic_cookie__headline {
    font-size: 2rem;
    text-transform: uppercase;
    font-weight: 800;
    line-height: 1;
    margin-bottom: 0;
    @media (min-width: 50rem) {
      width: 28rem;
      font-size: 2.75rem;
      font-weight: 800;
      line-height: 1;
    }
  }
  .civic_cookie__subheadline {
    font-weight: bold;
    margin: 1rem 0;
  }
  .civic_cookie__grid_body {
    @media (min-width: 50rem) {
      display: grid;
      gap: 1.75rem;
      grid-template-columns: 66% 33%;
    }
  }
  .civic_cookie__grid_list {
    @media (min-width: 50rem) {
      display: grid;
      grid-template-columns: 50% 50%;
      gap: 0.9375rem 0.625rem;
    }
  }
  .civic_cookie__bulletlist {
    margin-block-start: 0;
    margin-block-end: 0;
    padding-inline-start: 1.25rem;
  }
  .civic_cookie__button {
    border-radius: 0.25rem;
    border: 0.0625rem solid white;
    color: white;
    cursor: pointer;
    font-size: 0.875rem;
    font-weight: bold;
    padding: 0.75rem 1.25rem;
    text-align: center;
    text-decoration: none;
    @media (min-width: 37.5rem) {
      width: 100%;
    }
  }

  .civic_cookie__button--primary {
    color: red;
    background-color: white;
    margin-bottom: 1rem;
  }

  .civic_cookie__bold_text {
    font-size: 0.875rem;
    font-weight: bold;
    margin: 0.75rem 0;
  }
`

const CivicCookie = ({ bannerStyle }) => {
  const { trackEvent } = useAnalytics()
  const [isScriptLoaded, setIsScriptLoaded] = useState(false)
  const [isShown, setIsShown] = useState(false)
  const [cookiesAllowed, setCookiesAllowed] = useState(false)

  const toggleCookieBanner = bool => {
    setIsShown(bool)
    ls.set('civicCookie', { isOpen: bool }, { ttl: CIVIC_COOKIE_TTL })
  }

  const openCookieBanner = useCallback(() => {
    toggleCookieBanner(true)
  }, [])

  const closeCookieBanner = () => {
    toggleCookieBanner(false)
  }

  const acceptAllAndCloseCookieBanner = () => {
    window.CookieControl.acceptAll()
    toggleCookieBanner(false)
  }

  const rejectAllAndCloseCookieBanner = () => {
    trackEvent({
      action: 'button_click',
      category: Categories.CivicCookie,
      label: 'Reject All',
      location: Categories.CivicCookie,
    })
    trackEvent({
      action: 'analytics_consent_denied',
      category: Categories.CivicCookie,
      label: '',
      location: Categories.CivicCookie,
    })
    trackEvent({
      action: 'advertising_consent_denied',
      category: Categories.CivicCookie,
      label: '',
      location: Categories.CivicCookie,
    })
    window.CookieControl.rejectAll()
    toggleCookieBanner(false)
  }

  // Added custom events for motamo tracking
  const trackEvents = useCallback(
    e => {
      if (hasClass(e.target, 'civic_cookie__button--all')) {
        trackEvent({
          action: 'button_click',
          category: Categories.CivicCookie,
          label: 'Accept All',
          location: Categories.CivicCookie,
        })
      } else if (hasClass(e.target, 'civic_cookie__button--manage')) {
        trackEvent({
          action: 'button_click',
          category: Categories.CivicCookie,
          label: 'Manage Cookies',
          location: Categories.CivicCookie,
        })
      } else if (hasClass(e.target, 'ccc-close-button')) {
        trackEvent({
          action: 'button_click',
          category: Categories.CivicCookie,
          label: 'Save My Choices',
          location: Categories.CivicCookie,
        })
      } else if (hasClass(e.target, 'checkbox-toggle-input')) {
        if (e.target.nextSibling.innerHTML === 'Analytical Cookies') {
          trackEvent({
            action: 'toggled',
            category: Categories.CivicCookie,
            label: 'Analytical Cookies',
            location: Categories.CivicCookie,
          })
        } else if (e.target.nextSibling.innerHTML === 'Advertising Cookies') {
          trackEvent({
            action: 'toggled',
            category: Categories.CivicCookie,
            label: 'Advertising Cookies',
            location: Categories.CivicCookie,
          })
        }
      }
    },
    [trackEvent]
  )

  useEffect(() => {
    if (!ls.get('civicCookie') || ls?.get('civicCookie')?.isOpen === true) {
      openCookieBanner()
    }
    if (!isShown) {
      return
    }
    function trackEventsFunction(e) {
      trackEvents(e)
    }
    if (typeof window !== 'undefined') {
      window.addEventListener('click', trackEventsFunction, true)
    }
    // eslint-disable-next-line consistent-return
    return () => window.removeEventListener('click', trackEventsFunction, true)
  }, [isShown, openCookieBanner, trackEvents])

  const openCivicCookie = () => {
    window.CookieControl.open()
    closeCookieBanner()
  }

  const confName = () => {
    if (bannerStyle === 'ws') {
      return 'Web Summit'
    }
    if (bannerStyle === 'coll') {
      return 'Collision'
    }
    if (bannerStyle === 'rc') {
      return 'Rise'
    }
    return 'our conference'
  }

  useEffect(() => {
    if (navigator.cookieEnabled) {
      setCookiesAllowed(true)
    }
  }, [])

  if (!isScriptLoaded)
    return <CivicCookieSidebar bannerStyle={bannerStyle} setIsScriptLoaded={setIsScriptLoaded} />

  return (
    <>
      {cookiesAllowed ? (
        <CivicCookieBanner>
          <GlobalStyle bannerStyle={bannerStyle} />
          {isShown && (
            <>
              <div className="civic_cookie__overlay" />
              <div className={`civic_cookie__banner civic_cookie--${String(bannerStyle)}_style`}>
                <div>
                  <h2 className="civic_cookie__headline">Before you join us at {confName()}</h2>
                  <div className="civic_cookie__grid_body">
                    <div>
                      <div className="civic_cookie__subheadline">
                        We use cookies and similar technologies in the following ways:
                      </div>
                      <div className="civic_cookie__grid_list">
                        <ul className="civic_cookie__bulletlist">
                          <li>To recognise visitors and remember their preferences.</li>
                          <li>
                            For personalised ads and content, ad and content measurement, audience
                            insights, and product development.
                          </li>
                        </ul>
                        <div>
                          You can find out more in our <a href="/privacy-policy">privacy policy</a>{' '}
                          and <a href="/cookie-policy">cookie policy</a>, and can review your cookie
                          preferences at any time by selecting ’Manage my cookies’ at the bottom of
                          any page.
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="civic_cookie__bold_text"> </div>
                      <div
                        fullWidth
                        aria-hidden="true"
                        className="civic_cookie__button civic_cookie__button--primary civic_cookie__button--all"
                        data-test-id="cookie-acceptance-btn"
                        variant="contained"
                        onClick={() => acceptAllAndCloseCookieBanner()}
                      >
                        Accept All
                      </div>
                      <div
                        fullWidth
                        aria-hidden="true"
                        className="civic_cookie__button civic_cookie__button--primary civic_cookie__button--rejectAll"
                        data-test-id="cookie-acceptance-btn"
                        variant="contained"
                        onClick={() => rejectAllAndCloseCookieBanner()}
                      >
                        Reject All
                      </div>
                      <div
                        fullWidth
                        aria-hidden="true"
                        className="civic_cookie__button civic_cookie__button--manage"
                        variant="outlined"
                        onClick={() => openCivicCookie()}
                      >
                        Manage my cookies
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </CivicCookieBanner>
      ) : null}
    </>
  )
}

export default React.memo(CivicCookie)
